export default {
  langSep: '\u4E28',
  colon: '\uFF1A',
  searchPlaceholder: '\u8BF7\u8F93\u5165\u5173\u952E\u8BCD',
  siteTitle: '\u8BDA\u6D2A\u79D1\u6280',
  nav: {
    home: '\u9996\u9875',
    products: '\u4EA7\u54C1\u4E2D\u5FC3',
    solutions: '\u884C\u4E1A\u65B9\u6848',
    applications: '\u884C\u4E1A\u6848\u4F8B',
    news: '\u65B0\u95FB\u8D44\u8BAF',
    services: '\u670D\u52A1\u652F\u6301',
    about: '\u5173\u4E8E\u6211\u4EEC',
    contact: '\u8054\u7CFB\u6211\u4EEC'
  },
  common: {
    home: '\u9996\u9875',
    learnMore: '\u4E86\u89E3\u66F4\u591A',
    submit: '\u63D0\u4EA4',
    backToList: '\u8FD4\u56DE\u5217\u8868',
    more: '\u66F4\u591A+',
    inquiry: '\u4EA7\u54C1\u8BE2\u4EF7',
    summary: '\u6458\u8981',
    watchVideo: '\u89C2\u770B\u89C6\u9891',
    noContent: '\u6682\u65E0\u5185\u5BB9\u3002',
    noNews: '\u6682\u65E0\u76F8\u5173\u65B0\u95FB\u3002',
    noProducts: '\u8BE5\u5206\u7C7B\u6682\u65E0\u4EA7\u54C1\u3002',
    noProductsSearch: '\u672A\u627E\u5230\u76F8\u5173\u4EA7\u54C1\u3002',
    noCases: '\u8BE5\u5206\u7C7B\u6682\u65E0\u5E94\u7528\u6848\u4F8B\u3002',
    noNewsSearch: '\u672A\u627E\u5230\u76F8\u5173\u65B0\u95FB\u3002',
    contentSoon: '\u5185\u5BB9\u5373\u5C06\u4E0A\u7EBF\u3002',
    allNews: '\u5168\u90E8\u65B0\u95FB',
    newsDetail: '\u65B0\u95FB\u8BE6\u60C5'
  },
  news: {
    recommended: '\u63A8\u8350\u65B0\u95FB',
    fontSize: '\u5B57\u53F7',
    fontSmall: '\u5C0F',
    fontMedium: '\u4E2D',
    fontLarge: '\u5927',
    shareWechat: '\u5206\u4EAB\u5230\u5FAE\u4FE1',
    shareWeibo: '\u5206\u4EAB\u5230\u5FAE\u535A',
    shareQq: '\u5206\u4EAB\u5230QQ',
    shareVideo: '\u5206\u4EAB\u5230\u89C6\u9891\u53F7'
  },
  homeMenu: {
    page1: '\u8BDA\u6D2A\u79D1\u6280',
    page2: '\u4EA7\u54C1\u4E2D\u5FC3',
    page3: '\u884C\u4E1A\u6848\u4F8B',
    page4: '\u8BDA\u6D2A\u79D1\u6280',
    page5: '\u65B0\u95FB\u52A8\u6001'
  },
  home: {
    productsTitle: '\u4EA7\u54C1\u4E2D\u5FC3',
    productsDesc: '',
    solutionsTitle: '\u884C\u4E1A\u6848\u4F8B',
    oneStopTitle: '',
    oneStopDesc: '',
    leakTesters: '\u68C0\u6D4B\u4EEA',
    testFixtures: '\u6D4B\u8BD5\u6CBB\u5177',
    testPlatforms: '\u6D4B\u8BD5\u5E73\u53F0',
    aboutTitle: '',
    aboutSubtitle: '',
    aboutText: '',
    newsTitle: '\u65B0\u95FB\u52A8\u6001',
    newsSubtitle: '',
    newsEmpty: '\u6682\u65E0\u65B0\u95FB\u5185\u5BB9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u6216\u524D\u5F80\u65B0\u95FB\u5217\u8868\u9875\u67E5\u770B',
    statStandard: '\u9879\u6807\u51C6',
    statPatents: '\u8F6F\u8457\u53CA\u4E13\u5229',
    statCases: '\u5BA2\u6237\u6848\u4F8B',
    statBase: '\u751F\u4EA7\u57FA\u5730'
  },
  banner: {
    b1Title: '',
    b1Sub: '',
    b2Title: '',
    b2Sub: '',
    b3Title: '',
    b3Sub: '',
    b4Title: '',
    b4Sub: '',
    b5Title: '',
    b5Sub: ''
  },
  footer: {
    email: 'Email',
    hotline: '\u670D\u52A1\u70ED\u7EBF',
    headquarters: '\u603B\u90E8\u5730\u5740',
    factory: '\u751F\u4EA7\u57FA\u5730',
    links: '\u53CB\u60C5\u94FE\u63A5',
    icp: '',
    psb: '',
    companyName: '\u8BDA\u6D2A\u79D1\u6280\u6709\u9650\u516C\u53F8'
  },
  float: {
    contact: '\u8054\u7CFB\u6211\u4EEC',
    weekdays: '\u5DE5\u4F5C\u65E5',
    dayoff: '\u4F11\u606F\u65E5',
    onlineConsult: '\u8BDA\u6D2A\u79D1\u6280',
    contactBtn: '\u8054\u7CFB\u6211\u4EEC',
    intelligentService: '\u667A\u80FD\u5BA2\u670D',
    contactPhone: '\u7535\u8BDD\u8054\u7CFB',
    scanQr: '\u626B\u7801\u54A8\u8BE2',
    scanWechat: '\u5FAE\u4FE1\u626B\u7801',
    inquirePurchase: '\u54A8\u8BE2\u8D2D\u4E70',
    oneOnOne: '1\u5BF91\u4E13\u4E1A\u670D\u52A1',
    inquiry: '\u4EA7\u54C1\u8BE2\u4EF7',
    wechat: '\u5FAE\u4FE1',
    feedback: '\u610F\u89C1\u53CD\u9988',
    returnTop: '\u8FD4\u56DE\u9876\u90E8',
    wechatOfficial: '\u8BDA\u6D2A\u79D1\u6280\u5B98\u65B9\u5FAE\u4FE1\u516C\u4F17\u53F7'
  },
  contact: {
    phone: '\u7535\u8BDD',
    email: 'Email',
    address: '\u5730\u5740',
    pageTitle: '\u8054\u7CFB\u6211\u4EEC',
    name: '\u59D3\u540D',
    company: '\u516C\u53F8',
    message: '\u7559\u8A00',
    required: '*',
    success: '\u63D0\u4EA4\u6210\u529F\uFF0C\u611F\u8C22\u60A8\u7684\u7559\u8A00\uFF01',
    fail: '\u63D0\u4EA4\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002',
    navigate: '\u7ACB\u5373\u5BFC\u822A',
    hotline: '\u5BA2\u670D\u70ED\u7EBF',
    wechatService: '\u5FAE\u4FE1\u5BA2\u670D',
    branchesTitle: '\u5206\u516C\u53F8/\u529E\u4E8B\u5904',
    addressCard: '\u8BDA\u6D2A\u5730\u5740',
    emailCard: '\u8BDA\u6D2A\u90AE\u7BB1',
    hotlineCard: '\u670D\u52A1\u70ED\u7EBF',
    inquiryTitle: '\u5728\u7EBF\u7559\u8A00',
    inquiryType: '\u9700\u6C42\u7C7B\u578B',
    typeService: '\u670D\u52A1',
    typeMarket: '\u5E02\u573A',
    typeRecruit: '\u62DB\u8058',
    typeOther: '\u5176\u4ED6',
    submit: '\u7ACB\u5373\u63D0\u4EA4',
    reset: '\u91CD\u7F6E',
    companyFullName: '',
    namePh: '\u8BF7\u8F93\u5165\u60A8\u7684\u59D3\u540D',
    phonePh: '\u8BF7\u8F93\u5165\u60A8\u7684\u8054\u7CFB\u7535\u8BDD',
    phoneInvalid: '\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u7535\u8BDD\u53F7\u7801\uFF08\u624B\u673A\u6216\u5EA7\u673A\uFF09',
    emailPh: '\u8BF7\u8F93\u5165\u60A8\u7684\u90AE\u7BB1\u5730\u5740',
    companyPh: '\u8BF7\u8F93\u5165\u60A8\u7684\u516C\u53F8\u540D\u79F0',
    messagePh: '\u8BF7\u8F93\u5165\u60A8\u60F3\u8981\u54A8\u8BE2\u7684\u5177\u4F53\u5185\u5BB9'
  },
  search: {
    title: '\u641C\u7D22\u7ED3\u679C',
    resultsFor: '\u641C\u7D22\u5173\u952E\u8BCD',
    currentSearch: '\u5F53\u524D\u641C\u7D22\uFF1A',
    noResults: '\u672A\u627E\u5230\u76F8\u5173\u5185\u5BB9\u3002',
    products: '\u4EA7\u54C1',
    news: '\u65B0\u95FB'
  },
  faq: {
    pageTitle: '\u5E38\u89C1\u95EE\u9898\u53CA\u7B54\u7591',
    searchPlaceholder: '\u8F93\u5165\u4E3B\u673A\u7F16\u53F7\u6216\u8BBE\u5907\u578B\u53F7\uFF0C\u67E5\u770B\u4EA7\u54C1\u76F8\u5173\u95EE\u9898\u3002',
    searchHint: ''
  },
  service: {
    searchPlaceholder: '\u641C\u7D22',
    supportTitle: '\u4EA7\u54C1\u652F\u6301',
    breadcrumbService: '\u670D\u52A1\u652F\u6301'
  },
  about: {
    jobTitle: '\u804C\u4F4D\u540D\u79F0',
    jobLocation: '\u5DE5\u4F5C\u5730\u70B9',
    jobDept: '\u6240\u5C5E\u90E8\u95E8',
    jobType: '\u62DB\u8058\u7C7B\u578B',
    jobDate: '\u53D1\u5E03\u65E5\u671F'
  },
  newsType: {
    0: '\u6280\u672F\u767E\u79D1',
    1: '\u4F01\u4E1A\u65B0\u95FB',
    2: '\u5C55\u4F1A\u6D3B\u52A8',
    3: '\u884C\u4E1A\u8D44\u8BAF',
    4: '\u793E\u4F1A\u8D23\u4EFB'
  },
  productNav: {
    'bubble-leak': '\u6F0F\u6C14\u68C0\u6D4B',
    airtightness: '\u6C14\u5BC6\u6027\u68C0\u6D4B',
    'gas-detectors': '\u6C14\u4F53\u68C0\u6D4B',
    'mass-spectrometers': '\u8D28\u8C31\u68C0\u6D4B',
    'helium-leak': '\u6C26\u8D28\u8C31\u68C0\u6F0F\u4EEA',
    'test-platforms': '\u6D4B\u8BD5\u5E73\u53F0',
    fixtures: '\u6D4B\u8BD5\u5DE5\u88C5',
    accessories: '\u81EA\u52A8\u5316\u914D\u5957',
    'helium-leak-detector': '\u6C26\u8D28\u8C31\u68C0\u6F0F\u4EEA',
    'mass-spectrometer': '\u8D28\u8C31\u68C0\u6D4B',
    'gas-detector': '\u6C14\u4F53\u68C0\u6D4B',
    'leak-tester': '\u6C14\u5BC6\u6027\u68C0\u6D4B',
    'leak-point-detector': '\u6F0F\u70B9\u68C0\u6D4B\u4EEA',
    'test-platform': '\u6D4B\u8BD5\u5E73\u53F0'
  },
  productDetail: {
    overview: '\u4EA7\u54C1\u6982\u8FF0',
    specs: '\u89C4\u683C\u53C2\u6570',
    scenarios: '\u5E94\u7528\u573A\u666F',
    cases: '\u5E94\u7528\u6848\u4F8B',
    recommended: '\u76F8\u5173\u63A8\u8350',
    consult: '\u7ACB\u5373\u54A8\u8BE2',
    share: '\u5206\u4EAB',
    noSpecs: '\u6682\u65E0\u89C4\u683C\u53C2\u6570\u3002',
    noScenarios: '\u6682\u65E0\u5E94\u7528\u573A\u666F\u3002',
    noCases: '\u6682\u65E0\u5E94\u7528\u6848\u4F8B\u3002'
  },
  solutionNav: {
    'liquid-cooling': '\u6DB2\u51B7',
    automotive: '\u6C7D\u8F66',
    'hvac-refrigeration': '\u6696\u901A\u7A7A\u8C03/\u5236\u51B7',
    hvac: '\u7A7A\u8C03/\u5236\u51B7',
    energy: '\u80FD\u6E90',
    battery: '\u7535\u6C60',
    batteries: '\u7535\u6C60',
    semiconductor: '\u534A\u5BFC\u4F53',
    semiconductors: '\u534A\u5BFC\u4F53',
    'consumer-electronics': '\u6D88\u8D39\u7535\u5B50',
    'general-equipment': '\u901A\u7528\u8BBE\u5907',
    'medical-devices': '\u533B\u7597\u5668\u68B0',
    medical: '\u533B\u7597\u5668\u68B0',
    'home-appliances': '\u5BB6\u7535',
    'defense-aerospace': '\u56FD\u9632\u4E0E\u822A\u7A7A\u822A\u5929',
    aerospace: '\u56FD\u9632\u822A\u5929',
    'new-materials': '\u5148\u8FDB\u6750\u6599',
    'advanced-materials': '\u65B0\u6750\u6599',
    'wire-connector': '\u7EBF\u7F06\u4E0E\u8FDE\u63A5\u5668',
    'wires-connectors': '\u7EBF\u6750\u8FDE\u63A5',
    other: '\u5176\u4ED6',
    others: '\u5176\u4ED6'
  },
  applicationNav: {
    'liquid-cooling': '\u6DB2\u51B7',
    automotive: '\u6C7D\u8F66',
    'hvac-refrigeration': '\u6696\u901A\u7A7A\u8C03/\u5236\u51B7',
    hvac: '\u7A7A\u8C03/\u5236\u51B7',
    energy: '\u80FD\u6E90',
    battery: '\u7535\u6C60',
    batteries: '\u7535\u6C60',
    semiconductor: '\u534A\u5BFC\u4F53',
    semiconductors: '\u534A\u5BFC\u4F53',
    'consumer-electronics': '\u6D88\u8D39\u7535\u5B50',
    'general-equipment': '\u901A\u7528\u8BBE\u5907',
    'medical-devices': '\u533B\u7597\u5668\u68B0',
    medical: '\u533B\u7597\u5668\u68B0',
    'home-appliances': '\u5BB6\u7535',
    'defense-aerospace': '\u56FD\u9632\u4E0E\u822A\u7A7A\u822A\u5929',
    aerospace: '\u56FD\u9632\u822A\u5929',
    'new-materials': '\u5148\u8FDB\u6750\u6599',
    'advanced-materials': '\u65B0\u6750\u6599',
    'wire-connector': '\u7EBF\u7F06\u4E0E\u8FDE\u63A5\u5668',
    'wires-connectors': '\u7EBF\u6750\u8FDE\u63A5',
    other: '\u5176\u4ED6',
    others: '\u5176\u4ED6'
  },
  solutionSubNav: {
    uqd: 'UQD',
    'cold-plate': '\u51B7\u677F',
    manifold: '\u6B67\u7BA1',
    'corrugated-tube': '\u6DB2\u51B7\u6CE2\u7EB9\u7BA1',
    cdu: 'CDU',
    'liquid-cooling-cabinet': '\u6DB2\u51B7\u673A\u67DC',
    'die-castings': '\u538B\u94F8\u4EF6',
    valve: '\u9600\u95E8',
    'heat-exchanger': '\u6362\u70ED\u5668',
    'liquid-cooling-pump': '\u6DB2\u51B7\u6CF5',
    engine: '\u53D1\u52A8\u673A',
    battery: '\u7535\u6C60',
    transmission: '\u53D8\u901F\u7BB1',
    motor: '\u7535\u673A',
    ecu: '\u7535\u63A7',
    'camera-radar': '\u6444\u50CF\u5934/\u96F7\u8FBE',
    headlight: '\u8F66\u706F',
    'wire-harness': '\u7EBF\u675F',
    tpms: '\u80CE\u538B\u4F20\u611F\u5668',
    switch: '\u5F00\u5173',
    other: '\u5176\u4ED6',
    compressor: '\u538B\u7F29\u673A',
    pipeline: '\u7BA1\u8DEF',
    radiator: '\u6563\u70ED\u5668',
    'check-valve': '\u5355\u5411\u9600',
    'energy-storage': '\u50A8\u80FD',
    hydrogen: '\u6C22\u80FD\u6E90',
    'battery-cell': '\u7535\u82AF',
    pack: 'Pack',
    'soft-pack': '\u8F6F\u5305\u7535\u6C60',
    'safety-vent': '\u9632\u7206\u9600',
    'solid-state': '\u56FA\u6001\u7535\u6C60',
    phone: '\u624B\u673A',
    watch: '\u624B\u8868',
    'smart-band': '\u624B\u73AF',
    'ar-glasses': 'AR\u773C\u955C',
    earphone: '\u8033\u673A',
    tablet: '\u5E73\u677F',
    computer: '\u7535\u8111',
    speaker: '\u97F3\u7BB1',
    robot: '\u673A\u5668\u4EBA',
    sensor: '\u4F20\u611F\u5668',
    pump: '\u6CF5',
    cylinder: '\u6C14\u7F38',
    endoscope: '\u5185\u7AA5\u955C',
    stethoscope: '\u542C\u8BEA\u5668',
    aircraft: '\u98DE\u673A\u7C7B',
    uav: '\u65E0\u4EBA\u673A',
    missile: '\u5BFC\u5F39',
    satellite: '\u536B\u661F',
    connector: '\u8FDE\u63A5\u5668',
    'shock-absorber': '\u51CF\u9707\u5668',
    'water-tank': '\u6C34\u7BB1',
    'battery-pack': '\u7535\u6C60\u5305'
  },
  newsNav: {
    'tech-wiki': '\u6280\u672F\u767E\u79D1',
    'company-news': '\u4F01\u4E1A\u65B0\u95FB',
    exhibition: '\u5C55\u4F1A\u6D3B\u52A8',
    industry: '\u884C\u4E1A\u8D44\u8BAF',
    social: '\u793E\u4F1A\u8D23\u4EFB'
  },
  serviceNav: {
    'product-support': '\u4EA7\u54C1\u652F\u6301',
    'value-added': '\u589E\u503C\u670D\u52A1',
    faq: '\u5E38\u89C1\u95EE\u9898'
  },
  aboutNav: {
    'company-intro': '\u516C\u53F8\u4ECB\u7ECD',
    history: '\u53D1\u5C55\u5386\u7A0B',
    culture: '\u4F01\u4E1A\u6587\u5316',
    rd: '\u6280\u672F\u7814\u53D1',
    honors: '\u8363\u8A89\u8D44\u8D28',
    careers: '\u62DB\u8D24\u7EB3\u58EB'
  }
}
